<template>
    <div>
        <div class="breadcrumb-layout">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>报价</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-form>
            <div class="bid-container">
                <div class="content-caption dashed bg-white">
                    <span>询价信息</span>
                </div>
                <div class="form-single">
                    <div class="title">询价标题</div>
                    <div class="content">
                        <label class="mr20">{{priceReplyInfo.inqryTitle}}</label>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">询价方</div>
                    <div class="content">
                        <label class="mr20">{{priceReplyInfo.inqryMerchantName}}</label>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">询价日期</div>
                    <div class="content">
                        <label class="mr20">{{priceInpryInfo.publishTime}} ~ {{priceInpryInfo.expireDate}}</label>
                    </div>
                </div>

                <div class="content-caption dashed bg-white">
                    <span>询价服务</span>
                    <div class="fr font-gray1" style="font-size: 12px;">
                        优惠合计： <span class="font-bold" :class="{ 'font-red' : totalServcDiscount <= 0 , 'font-green' : totalServcDiscount >0 }">{{totalServcDiscount}}</span>
                    </div>
                </div>

                <div class="table-layout">
                    <el-table :data="priceReplyInfo.servcList" border style="width: 100%;">
                        <el-table-column prop="servcImage" width="150" label="服务图片" align="center">
                            <template slot-scope="rows">
                                <img :src="rows.row.servcImage"/>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="服务名称" align="left"></el-table-column>
                        <el-table-column prop="price" label="市场单价(元)" width="150" align="right">
                            <template slot-scope="rows">
                                <span>{{rows.row.priceNegoFlag ? '面议' : rows.row.price }}</span>
                            </template>
                        </el-table-column>

                        <el-table-column label="呈报单价(元)" width="120" align="center">
                            <template slot-scope="scope">
                                <input type="text" class="align-right" style="width: 100px;" v-model.number="scope.row.replyPrice" @blur="calcGoodsDiscount(scope.$index, scope.row)"/>
                            </template>
                        </el-table-column>

                        <el-table-column prop="discount" label="优惠小计(元)" width="120" align="right">
                            <template slot-scope="rows">
                                <span class="font-bold" :class="{ 'font-red' : rows.row.discount <=0 , 'font-green' : rows.row.discount >0 }">{{rows.row.discount}}</span>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
                <div class="form-single">
                    <div class="title">要求交付期</div>
                    <div class="content">
                        <span class="width-1-5x">&nbsp;&nbsp;{{priceReplyInfo.inqryDeliverPeriod}}<span class="ml15"></span><span class="ml30">天</span></span>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title required">呈报交付期</div>
                    <div class="content">
                        <el-form-item class="fl" prop="deliverPeriod">
                            <el-input style="width:140px" placeholder="" type="number" min="1" v-model="priceReplyInfo.deliverPeriod"></el-input>
                        </el-form-item>
                        <div class="fl font-gray1 ml10">天</div>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">联系人</div>
                    <div class="content">
                        <el-form-item prop="contactName">
                            <el-input class="width-1-5x" placeholder="" v-model="priceReplyInfo.contactName"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">联系电话</div>
                    <div class="content">
                        <el-form-item prop="contactTel">
                            <el-input class="width-1-5x" placeholder="" v-model="priceReplyInfo.contactTel"></el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-single">
                    <div class="title">交易规则</div>
                    <div class="content">
                        <swb-create-trade-rule :comparedTradeRuleList="comparedTradeRuleList" :type="tradeType" :forPriceInqry="forPriceInqry" :forGoods="forGoods" :forServc="forServc" :returnType="returnType" ref="swb_create_trade_rule"></swb-create-trade-rule>
                    </div>
                </div>

            </div>
        </el-form>
        <div class="form-toolbar align-center mt30" style="padding: 0;">
            <button class="swb-btn mr20" @click="savePriceInpry()">保存</button> <!-- true 是否保存 -->
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import priceApi from '../../api/price'

    import SwbCreateTradeRule from '../tradeRule/CreateTradeRule';
    Vue.regist(SwbCreateTradeRule);

    import SwbPriceReplyList from './PriceReplyList';
    Routes.add(SwbPriceReplyList);

    export default {
        name: 'swb-price-reply-save',
        path: '/price/reply/voucher/save',
        pathOld: '/price/reply/save',
        avlActions: '',
        avlScopes: 'servicer',
        notAsResc: true,
        authen: false,
        desc: '报价单编辑',
        data: function () {
            return {
                //询价单id
                inqryVoucherId: null,
                //
                priceInpryInfo: {},
                priceReplyInfo: {},
                //
                totalServcDiscount: null,
                //
                comparedTradeRuleList: [],
                tradeType: 'priceInqry',
                forPriceInqry: true,
                forGoods: false,
                forServc: true,
                returnType: 'priceReply'
            };

        },
        created: function () {
            //询价单id
            this.inqryVoucherId = this.$route.query.inqryVoucherId || null;
            this.priceVoucherId = this.$route.query.priceVoucherId || null;
            if(!Utils.isNoB(this.priceVoucherId)) {
                this.getpriceVoucherInfo(this.priceVoucherId);
            }
            if(!Utils.isNoB(this.inqryVoucherId)) {
                this.getPriceInpryInfo();
            }
            //
            this.getTradeRuleInfo();
        }
        ,
        methods: {

            getPriceInpryInfo: function () {
                let self = this;
                //
                let loading = MsgBox.loading();
                priceApi.getPriceInqryVoucherInfo(this.inqryVoucherId, function (result) {
                        if(result.type === "info") {
                            let priceInpryInfo = result.data;
                            let priceReplyInfo = self.priceReplyInfo || {};
                            //
                            priceReplyInfo.inqryVoucherId = priceInpryInfo.id;
                            priceReplyInfo.inqryVoucherNo = priceInpryInfo.no;
                            priceReplyInfo.inqryTitle = priceInpryInfo.title;
                            priceReplyInfo.tradeType = priceInpryInfo.tradeType;
                            priceReplyInfo.inqryMerchantId = priceInpryInfo.merchantId;
                            priceReplyInfo.inqryMerchantName = priceInpryInfo.merchantName;
                            priceReplyInfo.goodsFlag = priceInpryInfo.goodsFlag;
                            priceReplyInfo.servcFlag = priceInpryInfo.servcFlag;
                            priceReplyInfo.inqryDeliverPeriod = priceInpryInfo.deliverPeriod;
                            let priceInpryServcList = priceInpryInfo.servcList;
                            let priceReplyServcList = priceReplyInfo.servcList || [];
                            if(priceReplyServcList.length <= 0) {
                                if(priceInpryServcList != null && priceInpryServcList.length > 0) {
                                    for(var i = 0; i < priceInpryServcList.length; i++) {
                                        let priceInpryServc = priceInpryServcList[i];
                                        let priceReplyServc = {};
                                        //商品图片，仅显示用
                                        priceReplyServc.servcImage = priceInpryServc.servcImage;
                                        priceReplyServc.ssuId = priceInpryServc.ssuId;
                                        priceReplyServc.servcId = priceInpryServc.servcId;
                                        priceReplyServc.name = priceInpryServc.name;
                                        //
                                        priceReplyServc.priceNegoFlag = priceInpryServc.priceNegoFlag;
                                        if(priceInpryServc.priceNegoFlag) {//如果是面议,给报价服务赋值为null
                                            priceReplyServc.price = null;
                                        } else {
                                            priceReplyServc.price = priceInpryServc.price;
                                        }
                                        //
                                        if(priceReplyServc.price > 0) {
                                            priceReplyServc.price = priceReplyServc.price.round(2);
                                        }
                                        //表单中的输入框初始值设置不上
                                        priceReplyServc.replyPrice = null;
                                        //优惠小计，仅显示用
                                        priceReplyServc.discount = null;
                                        //表单中的输入框初始值设置不上
                                        priceReplyServcList.push(priceReplyServc);
                                    }
                                }
                            }

                            priceReplyInfo.servcList = priceReplyServcList;

                            self.priceInpryInfo = priceInpryInfo;
                            self.priceReplyInfo = priceReplyInfo;
                            loading.close();
                        } else {
                            loading.close();
                            MsgBox.warning(result.message);
                        }
                    }
                );
            },

            getpriceVoucherInfo: function (priceVoucherId) {
                let self = this;
                priceApi.getPriceReplyVoucherInfo(priceVoucherId, function (result) {
                    if(result.type == 'info') {
                        let priceReplyInfo = result.data;
                        self.inqryVoucherId = priceReplyInfo.inqryVoucherId;
                        self.priceReplyInfo = priceReplyInfo;
                        self.getPriceInpryInfo();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
            ,

            getTradeRuleInfo: function () {
                let self = this;
                let postData = {};
                postData.voucherId = self.inqryVoucherId;
                let loading = MsgBox.loading();
                priceApi.getPriceInqryTermList(postData, function (result) {
                    if(result.type == 'info') {
                        let priceInqryTermList = result.data;
                        if(priceInqryTermList != null && priceInqryTermList.length > 0) {
                            self.comparedTradeRuleList = priceInqryTermList;
                            self.$refs.swb_create_trade_rule.getTradeRule();
                            loading.close();
                        }
                    }
                });
            }
            ,
            //同步计算优惠小计
            calcGoodsDiscount(rowIndex, rowData)
            {
                let replyPrice = Utils.ParseFloat(rowData.replyPrice);
                let actualPrice = null;
                //
                let replyPriceOk = true;
                if(replyPrice == null || replyPrice <= 0) {
                    replyPriceOk = false;
                }
                else {
                    actualPrice = replyPrice.round(2);
                    if(actualPrice != replyPrice) {
                        replyPriceOk = false;
                    }
                }
                //
                rowData.discount = replyPriceOk ? (rowData.price - actualPrice).round(2) : null;
                //
                this.$set(this.priceReplyInfo.servcList, rowIndex, rowData);
                //计算总优惠合计
                let servcDiscounts = this.priceReplyInfo.servcList.pluck('discount');
                servcDiscounts = servcDiscounts.filter(function (discount) {
                    return discount !== null;
                });
                if(servcDiscounts.length > 0) {
                    this.totalServcDiscount = servcDiscounts.sum().round(2);
                }
                else {
                    this.totalServcDiscount = null;
                }
            }
            ,

            savePriceInpry: function () {
                let priceReplyInfo = Utils.merge({}, this.priceReplyInfo);
                //检查 报价商品
                let servcList = priceReplyInfo.servcList;
                for(let i = 0; i < servcList.length; i++) {
                    let servc = servcList[i];
                    let replyPrice = servc.replyPrice;
                    if(!Utils.isNumStr(replyPrice)) {
                        Toast.show('第 ' + (i + 1) + ' 个服务 ： 呈报单价 必填 且 必须为大于0的 金额数字（最多2位小数）', 3000, 'warning');
                        return false;
                    }
                    replyPrice = Utils.ParseFloat(replyPrice);
                    if(replyPrice <= 0) {
                        Toast.show('第 ' + (i + 1) + ' 个服务 ： 呈报单价 必须为大于0的 金额数字（最多2位小数）', 3000, 'warning');
                        return false;
                    }
                    let actualPrice = replyPrice.round(2);
                    if(actualPrice != replyPrice) {
                        Toast.show('第 ' + (i + 1) + ' 个服务 ： 呈报单价 最多2位小数', 3000, 'warning');
                        return false;
                    }
                    servc.replyPrice = actualPrice;
                    //
                }
                if(!Utils.isNoB(priceReplyInfo.contactTel)) {
                    if(!Utils.isPhoneNo(priceReplyInfo.contactTel)) {
                        Toast.show('请填写正确的联系电话');
                        return false;
                    }
                }
                //检查 交付期
                let deliverPeriod = priceReplyInfo.deliverPeriod || null;
                if(!Utils.isNaturalStr(deliverPeriod, true)) {
                    Toast.show('交付期 必填 且 必须为大于0的 整数', 3000, 'warning');
                    return false;
                }

                //保存条款
                let termList = priceReplyInfo.itemList || [];
                if(termList.length > 0) {
                    let resultRule = this.$refs.swb_create_trade_rule.getResult();
                    if(resultRule.type == 'info') {
                        let termList = resultRule.data;
                        for(var i = 0; i < termList.length; i++) {
                            termList[i].priceReplyTermValueList = Utils.copyAsArray(termList[i].termValList);
                        }
                        priceReplyInfo.termList = termList;
                    } else {
                        Toast.show(resultRule.message, 3000, 'warning');
                        return false;
                    }
                }
                //
                let self = this;
                let loading = MsgBox.loading();
                priceApi.savePriceReplyVoucher(priceReplyInfo, function (result) {
                    if(result.type == 'info') {
                        loading.close();
                        MsgBox.success("保存报价成功");
                        self.toPriceInpry();
                    } else {
                        loading.close();
                        MsgBox.failure(result.message);
                    }
                });
            }
            ,

            toPriceInpry: function () {
                this.$router.push({
                    path: SwbPriceReplyList.path
                });
            }
            ,
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/priceReply/PriceReplySave.vue